<template>
    <el-popover
        width="700"
        placement="right-start"
        trigger="hover"
        :open-delay="800"
        :close-delay="500"
        @after-enter="loadData">

        <!-- 直接展示部分 -->
        <span slot="reference">
            <a :class="{_ticket_title_a:isDashboard}"
                :target="target"
                :href="'/ticket/t/' + ticketNo"
                :title="ticketTitle">{{ticketTitle?ticketTitle:ticketNo}}</a>
        </span>

        <!-- 浮窗部分 -->
        <div style="max-height:350px;overflow:auto;">
          <div class="f-box">
            <div class="_div_10">
                <span class="_label_11">工单编号</span>
                <span>{{ticket.orderId}}</span>
                <TicketShare :ticket="ticket" mode='view'/>
            </div>
            <div class="_div_10">
                <span class="_label_11">创建时间</span>
                <span>{{ticket.createdAt}}</span>
            </div>
          </div>
          <div class="f-box">
            <div class="_div_10">
                <span class="_label_11">更新时间</span>
                <span>{{ticket.updatedAt}}</span>
            </div>
            <div class="_div_10">
                <span class="_label_11">截止时间</span>
                <span>{{ticket.endAt}}</span>
            </div>
          </div>
            <div style="padding-bottom:5px;">
                <span class="_label_11">最新回复</span>
            </div>

            <TicketEventList v-if="!!ticketEventList" :ticketEventList="ticketEventList"/>

            <div style="padding-left:20px;font-size:15px;" v-if="!ticketEventList">加载中...</div>
        </div>
    </el-popover>
</template>

<script>
export default {
  name: "TicketTitle",

  props: ['ticketNo', 'ticketTitle', 'target'],

  data() {
      return {
          isDashboard : false,
          ticketEventList : null,
          ticket : {}
      };
  },

  mounted() {
    // Dashboard 模式, 工单标题单行展示
    if ( "8" == this.$route.query.ticketType ) {
      this.isDashboard = true;
    }
  },

  methods: {
      loadData() {
        this.loadTicket();
      },

      loadTicket() {
        var _this = this;

        // 禁止 loading 干扰 hover
        window._doNotShowLoading = true;

        sdk.TicketApi().findByOrderId({
            orderId : _this.ticketNo
        }).then(res => {
            _this.ticket = res;

            window._doNotShowLoading = false;

            _this.loadTicketEvent(); // 加载工单信息完成后 加载回复(表单)
        }, err => {
          window._doNotShowLoading = false;

          console.log('#304 TicketApi findByOrderId error', err);

          if ( 'ticket_not_visible' == err ) {
            _this.ticketEventList = []; // 将加载中变为加载完成 好像没生效

            _message('你没有权限查看这个工单 ' + _this.ticketNo);
            return;
          }
        });
      },

      loadTicketEvent() {
        var _this = this;

        // 禁止 loading 干扰 hover
        window._doNotShowLoading = true;

        sdk.TicketEventApi().listByTicketNo({
            ticketNo : _this.ticketNo,
            page : { pageSize : 9, orderBy : '`flow_id` DESC' }
        }).then(page => {
            _this.ticketEventList = page.list;

            window._doNotShowLoading = false;
        });
      }
  }
}
</script>

<style>
.f-box {
  display: flex;
}

._div_10 {
    width : 48%;
    padding-bottom:5px;
    flex: 1;
}

._label_11 {
    padding-left:20px;
    font-size:16px;
    display:inline-block;
    width: 100px;
    color:#a1a1a1;
}

._ticket_title_a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketTitle.vue